import React, { FC } from 'react';
import './FeatureCard.css';

interface FeatureCardProps {
  iconSrc: string;
  title: string;
  description: string;
}

export const FeatureCard: FC<FeatureCardProps> = ({ iconSrc, title, description }) => {
  return (
    <div className="feature-card">
      <div className="title-container">
        <img src={iconSrc} alt={title} />
        <h4>{title}</h4>
      </div>
      <p>{description}</p>
    </div>
  );
};